import React from 'react';
import Modal from '../components/Modal';

export default function UnsavedChangesModal({ onConfirm, onCancel }) {
	/**
	 * The Modal will call this method when an attempt is made to close the Modal by clicking
	 *  outside or pressing 'Escape'.
	 * Prevent the event propagation and return false to disable auto-close behavior.
	 */
	const preventClose = (evt) => {
		evt.preventDefault();
		return false;
	};

	return (
		<Modal
			title="Unsaved changes will be lost"
			id="mbiConfirmation-modal"
			doConfirm={preventClose}
			hideCloseX={true}
			cancelAction="Cancel"
			onCancel={onCancel}
			confirmAction="Continue"
			onSave={onConfirm}
		>
			<div>
				You have unsaved changes that will be lost if you continue. If you do not want to lose your changes,
				please click Cancel to go back and save your changes.
			</div>
		</Modal>
	);
}
